import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getByCategory } from "@/lib/content";

export default function CategoryEntries() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const count = getByCategory(cat.key).length;
            return (
              <Link
                key={cat.key}
                to={cat.path}
                className="group rounded-xl bg-background-50 border border-background-200 p-5 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-2xl text-primary-600`} />
                  </span>
                  <span className="text-xs text-foreground-400">
                    {count} 篇内容
                  </span>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 font-medium">
                  进入栏目
                  <i className="ri-arrow-right-s-line group-hover:translate-x-0.5 transition-transform" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}